import { Divider, Typography } from 'antd';
import LinkinAccountAmazon from './LinkingAccountAmazon';

export default function LinkingAccountsPage() {
  return (
    <div className="page account-page-wrapper">
      <Typography.Title style={{ marginTop: 0 }} level={3}>
        Vinculação de contas
      </Typography.Title>

      <Divider />

      <LinkinAccountAmazon />

      <Divider />
    </div>
  );
}
